import router from '../router'
export function toPay(res) {
    console.log(res.data,'支付回调');

    if (res.msg == 'jt') {
        let html = res.data;

        router.push({ name: 'jtBank', params: { linkHtml: html } })
    } else if (res.msg == 'szb') {
        if (res.data.html) {//支付宝
            console.log("跳转支付宝");
            console.log(res.data.html,"跳转支付宝");
            
            router.push({ name: 'nbBank', params: { linkHtml: res.data.html } })
        } else {//微信
            console.log();
            
            this.$wxPay.checkIsWeixinJSBridge(JSON.parse(res.data.payInfo));
        }
    } else if (res.msg == 'lklPay') {
        if (res.data.code) {//支付宝

            window.location.href = res.data.code;
        } else {//微信

            this.$wxPay.checkIsWeixinJSBridgeLkl(res.data);
        }
    } else if (res.msg == 'zfzhqz') {

        window.location.href = res.data.codeUrl;
    } else if(res.msg == 'ys'){
       console.log(res,'易生支付');
        if (res.data.appId) {

            this.$wxPay.checkIsWeixinJSBridge(res.data);
        }else{
            window.location.href = res.data;
        }
        

    }else {
 

        window.location.href = res.data;
    }
}

 
export function roadsidePay(res) {

    if (res.msg == 'jt') {
        let html = res.data;
        
        router.push({ name: 'jtBank', params: { linkHtml: html } })
    } else if (res.msg == 'szb') {
        if (res.data.html) {//支付宝

            router.push({ name: 'nbBank', params: { linkHtml: res.data.html } })
        } else {//微信
            console.log("跳转微信");
            this.$roadsidewxPay.checkIsWeixinJSBroadside(JSON.parse(res.data.payInfo));
        }
    } else if (res.msg == 'lklPay') {
        if (res.data.code) {//支付宝
            window.location.href = res.data.code;
        } else {//微信

            this.$roadsidewxPay.checkIsWeixinJSBroadside(res.data);
        }
    } else if (res.msg == 'zfzhqz') {
        window.location.href = res.data.codeUrl;
    }  else if(res.msg == 'ys'){
        this.$wxPay.checkIsWeixinJSBridgeLkl(res.data);
    }else {


        window.location.href = res.data;
    }
}
